// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-string-field';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.125 2.811V2.25A1.688 1.688 0 0 1 2.813.561h12.374a1.687 1.687 0 0 1 1.688 1.689v.563M9 .561v16.875m-3.375 0h6.75'
  />
);

export const viewBox = '0 0 18 18';
